import axios from "../../utility/axiosInstance";


export async function getJobs() {
    const response = await axios.get("/jobs")

    return response.data
}

export async function createJob(obj) {
    const response = await axios.post("/jobs", obj)

    return response.data
}

export async function editJob(obj) {
    const response = await axios.patch(`/jobs/${obj.id}`, obj)

    return response.data
}


export async function removeJob(id) {
    const response = await axios.delete(`/jobs/${id}`)

    return response.data
}